import React from 'react';
import { Box, Card, CardContent, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { MetricConfig } from './types/analytics.type';

interface MetricCardProps {
  config: MetricConfig;
  value: number;
  isLoading: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({ config, value }) => {
  return (
    <Card sx={{ maxWidth: 450, borderRadius: 2, borderWidth: 1, borderStyle: 'solid', borderColor: 'divider', fontFamily: 'Poppins, sans-serif'}}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
          <Tooltip title={config.label} arrow placement="top">
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ 
                fontSize: '1rem', 
                fontWeight: 400, 
                fontFamily: 'Poppins, sans-serif',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                cursor: 'pointer'
              }}
            >
              {config.label}
            </Typography>
          </Tooltip>
          {config.tooltip && (
            <Tooltip title={config.tooltip} arrow>
              <InfoOutlinedIcon sx={{ fontSize: '16px', color: '#5F6B7A', cursor: 'pointer', flexShrink: 0, ml: 0.5 }} />
            </Tooltip>
          )}
        </Box>
        <Typography
          variant="h2"
          component="div"
          sx={{
            fontSize: '2rem',
            fontWeight: 700,
            color: config.valueColor || 'text.primary',
            lineHeight: 1,
            fontFamily: 'Poppins, sans-serif'
          }}
        >
          {value}
          {config.suffix || ''}
        </Typography>
      </CardContent>
    </Card>
  );
};
export default MetricCard;